var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 67,
    viewBox: "0 0 47 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0C10.5079 0 0 10.4855 0 23.45C0 41.0375 23.5 67 23.5 67C23.5 67 47 41.0375 47 23.45C47 10.4855 36.4921 0 23.5 0ZM23.5 31.825C18.8671 31.825 15.1071 28.073 15.1071 23.45C15.1071 18.827 18.8671 15.075 23.5 15.075C28.1329 15.075 31.8929 18.827 31.8929 23.45C31.8929 28.073 28.1329 31.825 23.5 31.825Z",
    fill: "#2A302A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.26f45d47ec02be5173119c5332e0ccde.svg";
export { ForwardRef as ReactComponent };